import { cn } from '../../lib/utils';

export interface InlineNumberProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export function InlineNumber({
  value,
  onChange,
  min = 0,
  max = 99,
  className,
}: InlineNumberProps) {
  const clamp = (n: number) => Math.max(min, Math.min(max, n));
  return (
    <div
      className={cn(
        'inline-flex items-center bg-white border border-border rounded-md overflow-hidden',
        className
      )}
    >
      <button
        type="button"
        onClick={() => onChange(clamp(value - 1))}
        aria-label="decrement"
        className={cn(
          'w-[22px] h-6 bg-white border-0 border-r border-borderSoft cursor-pointer',
          'font-mono text-[13px] font-bold text-textMute hover:bg-bg'
        )}
      >
        −
      </button>
      <input
        type="number"
        value={value}
        onChange={e => onChange(clamp(parseInt(e.target.value, 10) || 0))}
        className={cn(
          'w-10 h-6 p-0 text-center bg-white border-0 outline-none',
          'font-mono text-[12px] font-bold text-text'
        )}
      />
      <button
        type="button"
        onClick={() => onChange(clamp(value + 1))}
        aria-label="increment"
        className={cn(
          'w-[22px] h-6 bg-white border-0 border-l border-borderSoft cursor-pointer',
          'font-mono text-[13px] font-bold text-textMute hover:bg-bg'
        )}
      >
        +
      </button>
    </div>
  );
}

InlineNumber.displayName = 'InlineNumber';

export default InlineNumber;
